<template>
  <div class="flex items-center justify-between space-x-4">
    <div>
      <div class="flex items-center font-semibold">
        {{ addon.name }} 
      </div>
      <div class="text-gray-500">
        <currency :value="addon.price" :currency-code="account.currency" :subunits-value="true" />
      </div>
    </div>
    <div>
      <button type="button" class="py-1 text-red-500 hover:underline" @click="showRemove = true">
        Remove
      </button>
    </div>

    <Modal :open.sync="showRemove" size="max-w-lg" title="Remove Product">
      <div class="p-6">
        <div> 
          Are you sure you want to remove <strong>{{ addon.name }}</strong> from this address?
        </div>
      </div>
      <div class="flex p-6 border-t gap-x-2">
        <button class="btn btn-red" v-submitting="submitting" @click="removeAddon">
          Yes, Remove It
        </button>
        <button class="btn btn-secondary" v-submitting="submitting" @click="showRemove = false">
          Cancel
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BookingAddressAddon',

  props: {
    addon: {
      type: Object,
      required: true
    },

    addressType: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () { 
    return {
      submitting: false,
      showRemove: false
    }
  },

  methods: {
    async removeAddon () {
      try {
        this.submitting = true
        const { data } = await this.$api.delete(`account/${this.$route.params.account}/booking-${this.addressType}-addons/${this.addon.id}`)
        this.showRemove = false
        this.$emit('deleted', data.addon)
      } catch (error) {
        console.error(error)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>